angular.module('SpidApp')

.factory('LoginService',
        ['Restangular', '$window', '$q', '$localStorage', 'User', 'RandomStringGenerator', 'ResetPasswordMailer', 'UserService',
function (Restangular,   $window,   $q,   $localStorage,   User,   RandomStringGenerator,   ResetPasswordMailer, UserService) {
	
	var LoginService = {
		isLoggedIn : function () {
			return !!$localStorage.auth && $localStorage.auth.basic
		},
		
		/**
		 * Log the user in,
		 * @return a promise resolved with a users
		 */
		login : function(username, password) {
			if (!username || username === '' ||
				!password || password === '') {
				
				return $q(function (resolve, reject) {
					reject(new Error('LoginService::login() - Missing parameters'))
				})
			}
			
			Restangular.setDefaultHeaders({
				Authorization: 'Basic ' + $window.btoa(username + ':' + password)
			});
			
			return Restangular.one('users').customPOST({ username: username}, 'login', {}, {}).then(function (userData) {
				$localStorage.auth = {
					basic: Restangular.defaultHeaders.Authorization
				}
				
				userData.roles = userData.roles.split(',')

				return new User(userData)
			}).catch(function () {
				LoginService.logout()
				
				throw new Error('LoginService::login() - Bad login/password')
			})
		},
		
		logout : function () {
			delete Restangular.defaultHeaders.Authorization
			delete $localStorage.auth
			
			return $q.when()
		},
		
		resetPassword: function (email) {
			if (!email || email.length === 0) {
				throw 'LoginService::resetPassword() - Missing parameters'
			}
			
			var newPassword = RandomStringGenerator(10)

			return UserService.findByEmail(email).then(function(data){

                var mail = new ResetPasswordMailer({to: email, newPassword: newPassword, name: data.lastname})

                return mail.send().then(function (response) {
                    if (response.code !== 200) {
                        throw response.message
                    }

                    return response
                }).then(function () {
                    return UserService.resetPassword(email, newPassword)
                })
			})
		}
	}
	
	return LoginService
}])
